import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  CartSummaryWrapper,
  PriceColumns,
  PriceColumn,
  PriceLabel,
  PriceValue,
  CartIconSection,
  CartIconButton,
  CartBadge,
} from './CartSummary.styles';

const CartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);


const CartSummary = ({
  onCartIconClick,
  isCartOpen,
  itemCount,
  displayMode,
}) => {
  const { today, monthly, savings } = useSelector((state) => {
    const orderView = state?.cartDetails?.cartDetailsJson?.orderDetailsView;
    const checkoutOrder = state?.checkout?.orderDetails;

    return {
      today: orderView?.dueTodayAmount ?? checkoutOrder?.totalDueToday ?? 0,
      monthly: orderView?.dueMonthlyAmount ?? checkoutOrder?.totalMonthlyDue ?? 0,
      savings: orderView?.dueMonthlyDiscountAmount ?? checkoutOrder?.dueMonthlyDiscountAmount ?? 0,
    };
  });

  return (
    <CartSummaryWrapper displayMode={displayMode} data-testid="cart-summary">
      <PriceColumns displayMode={displayMode}>
        <PriceColumn>
          <PriceLabel>Today</PriceLabel>
          <PriceValue data-testid="cart-summary-today">${Number(today).toFixed(2)}</PriceValue>
        </PriceColumn>

        <PriceColumn>
          <PriceLabel>Monthly</PriceLabel>
          <PriceValue data-testid="cart-summary-monthly">${Number(monthly).toFixed(2)}</PriceValue>
        </PriceColumn>

        {Number(savings) > 0 && (
          <PriceColumn>
            <PriceLabel isSavings>Savings</PriceLabel>
            <PriceValue isSavings data-testid="cart-summary-savings">
              ${Number(savings).toFixed(2)}
            </PriceValue>
          </PriceColumn>
        )}
      </PriceColumns>

      <CartIconSection>
        <CartIconButton
          type="button"
          onClick={onCartIconClick}
          aria-label={isCartOpen ? 'Close cart summary' : 'Open cart summary'}
          aria-expanded={isCartOpen}
          aria-haspopup="dialog"
          data-testid="cart-icon-button"
          data-track={JSON.stringify({ type: 'link', name: 'cart icon - progressbar' })}
        >
          <CartIcon />
          {itemCount > 0 && (
            <CartBadge aria-hidden="true">{itemCount}</CartBadge>
          )}
        </CartIconButton>
      </CartIconSection>
    </CartSummaryWrapper>
  );
};

CartSummary.propTypes = {
  onCartIconClick: PropTypes.func.isRequired,
  isCartOpen: PropTypes.bool.isRequired,
  itemCount: PropTypes.number,
  displayMode: PropTypes.oneOf(['desktop', 'mobile']),
};

CartSummary.defaultProps = {
  itemCount: 0,
  displayMode: 'desktop',
};

export default CartSummary;
